import { render, staticRenderFns } from "./CryptoDepositForm.vue?vue&type=template&id=0812d6ea&scoped=true"
import script from "./CryptoDepositForm.vue?vue&type=script&lang=js"
export * from "./CryptoDepositForm.vue?vue&type=script&lang=js"
import style0 from "./CryptoDepositForm.vue?vue&type=style&index=0&id=0812d6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812d6ea",
  null
  
)

export default component.exports